import $ from 'jquery';
import Dropzone from 'dropzone/src/dropzone';

Dropzone.autoDiscover = false;
